import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine1Caption3Secondary extends ITextBoxProps {}

export const TextBoxMaxLine1Caption3Secondary = ({
  title,
  color = Colors.TEXT_ICON_SECONDARY,
  font = TextBoxTypes.Caption3,
  alignment = TextAligning.Left,
  maxLines = 1,
  ...rest
}: ITextBoxMaxLine1Caption3Secondary): JSX.Element => {
  return (
    <TextBox
      title={title}
      color={color}
      font={font}
      alignment={alignment}
      maxLines={maxLines}
      {...rest}
    />
  )
}
